import React, { Suspense, lazy } from "react";
import { aiContentCluster, getRelatedMoneyPages, getRelatedIndustryPages, getRelatedInsightPages } from "@/data/contentClusters";

const MoneyPageTemplate = lazy(() => import("@/components/templates/MoneyPageTemplate").then((m) => ({ default: m.MoneyPageTemplate })));

const pageData = aiContentCluster.moneyPages.find(p => p.slug === "seo-content-saas")!;
const relatedMoney = getRelatedMoneyPages("ai-content").filter(p => p.slug !== pageData.slug);
const relatedIndustry = getRelatedIndustryPages("ai-content");
const relatedInsights = getRelatedInsightPages("ai-content");

export default function SEOContentSaaSPage() {
  return (
    <Suspense fallback={<div className="container-wide py-24">Loading…</div>}>
      <MoneyPageTemplate
        page={pageData}
        pillarTitle={aiContentCluster.pillar.subtitle}
        relatedMoneyPages={relatedMoney.map(p => ({ title: p.title, slug: p.slug }))}
        relatedIndustryPages={relatedIndustry.map(p => ({ title: p.title, slug: p.slug }))}
        relatedInsightPages={relatedInsights.map(p => ({ title: p.title, slug: p.slug }))}
      />
    </Suspense>
  );
}
